import type { MagneticWallType } from '../../editorSlice';
import Annotation from '../Annotation';
import Comment from '../Comment';
import Reaction from '../Reaction';

export type MagneticWallAttributor =
  | typeof Comment
  | typeof Annotation
  | typeof Reaction;

const attributorsMap: Record<MagneticWallType, MagneticWallAttributor> = {
  comment: Comment,
  annotation: Annotation,
  reaction: Reaction,
};

export function getAttributorFromMagneticWallType(type: MagneticWallType) {
  return attributorsMap[type];
}

type ClosestAttribute = {
  attributor: MagneticWallAttributor;
  id: string;
  node: Element;
};

export function getAttributorType(
  attributor: MagneticWallAttributor,
): MagneticWallType {
  return attributor.keyName as MagneticWallType;
}

export function getClosestAttribute(target: Element): ClosestAttribute | null {
  // eslint-disable-next-line no-restricted-syntax
  for (const attributor of [Comment, Annotation, Reaction]) {
    const node = target.closest(`[class*="${attributor.keyName}-"]`);
    const id = node instanceof HTMLElement && attributor.value(node)?.[0];
    if (typeof id === 'string' && node) {
      return { attributor, id, node };
    }
  }
  return null;
}
